<template>
  <DropDownMenu drop-down-icon="none" class="is-flex-grow-1">
    <template v-slot:trigger>
      <button class="button">
        <ChannelIcon class="button__label-icon" :channelType="value.type" />
        <span class="button__label">
          {{ value.name }}
        </span>
        <span class="icon">
          <font-awesome-icon icon="angle-up"></font-awesome-icon>
        </span>
      </button>
    </template>
    <div class="scrollable-item-list">
      <a @click="value = option" class="dropdown-item" v-for="option in channelIdentities" :key="option.id">
        <ChannelIcon class="scrollable-item-list__icon" :channelType="option.type" />
        <span class="item-title">{{ option.name }}</span>
      </a>
    </div>
  </DropDownMenu>
</template>

<script lang="ts" setup>
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import ChannelIcon from '@/shared/icons/ChannelIcon.vue';
import { computed, onMounted, PropType } from 'vue';
import { useStore } from 'vuex';
import { useVModel } from '@vueuse/core';

const props = defineProps({
  modelValue: {
    type: Object as PropType<ChannelIdentityViewModel>,
    required: true,
  },
});
const emit = defineEmits<{
  (e: 'update:modelValue', value: Date): void;
}>();
const value = useVModel(props, 'modelValue', emit);

const store = useStore();
const channelIdentities = computed<ChannelIdentityViewModel[]>(() => store.getters.channelIdentities);

onMounted(() => {
  if (!value.value && channelIdentities.value?.length > 0) {
    value.value = channelIdentities.value[0];
  }
});
</script>

<style scoped lang="scss">
.button {
  white-space: normal;
  &__label {
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
    width: 150px;
    white-space: nowrap;
  }

  &__label-icon {
    vertical-align: middle;
    margin-right: 0.6rem;
    width: 18px;
    height: 18px;
  }
}

.scrollable-item-list {
  max-height: 250px;
  overflow-y: auto;

  &__icon {
    vertical-align: middle;
    margin-right: 0.6rem;
    width: 18px;
    height: 18px;
  }
}
:deep(.dropdown-menu) {
  top: auto;
  bottom: 100%;
  a {
    color: $color-netcall-body-text;
  }
}
</style>
